import LegalLayout, { H2, P, UL, PH } from "../LegalLayout";

export default function Rueckgabe() {
  return (
    <LegalLayout title="Rückgabe- und Erstattungsrichtlinien">
      <P>
        Diese Richtlinien ergänzen dein gesetzliches{" "}
        <a href="/widerruf" className="text-gold underline underline-offset-4">
          Widerrufsrecht
        </a>
        . Alle konkreten Fristen und Wege sind Platzhalter und müssen vor Veröffentlichung ausgefüllt werden.
      </P>

      <H2>Rückgabe im Rahmen des Widerrufs</H2>
      <UL
        items={[
          "Nach deinem Widerruf (innerhalb von 14 Tagen, siehe Widerrufsbelehrung) sendest du die Ware zurück.",
          <>
            <PH>
              Rücksendeadresse: [deine Rückgabeadresse eintragen] — Rücksendekosten: [trägst du / trägt der Kunde —
              verbindlich festlegen, wie in der Widerrufsbelehrung].
            </PH>
          </>,
          "Ware sollte ungetragen, ungewaschen und mit Etikett zurückkommen; aus Hygienegründen gilt für entsiegelte Bandagen der Ausschluss (siehe Widerrufsbelehrung).",
        ]}
      />

      <H2>Erstattung</H2>
      <UL
        items={[
          "Nach Widerruf erstatten wir alle Zahlungen einschließlich der Standard-Lieferkosten spätestens 14 Tage nach Zugang deiner Widerrufserklärung.",
          <>
            Die Erstattung erfolgt über dasselbe Zahlungsmittel ( Stripe-Rückzahlung auf deine Karte/dein Zahlungsmittel) —{" "}
            <PH>[abweichende Regelung, falls gewünscht, hier eintragen]</PH>
          </>,
          <>
            Wir dürfen die Erstattung verweigern, bis wir die Ware zurückerhalten haben oder du den Nachweis der
            Rücksendung erbracht hast —{" "}
            <PH>[alternativ: frühere Erstattung mit Versandbeleg, falls du das anbieten willst]</PH>
          </>,
        ]}
      />

      <H2>Defekte oder falsch gelieferte Ware (Gewährleistung)</H2>
      <P>
        Bei Mängeln gelten die gesetzlichen Gewährleistungsrechte: Kontaktiere uns mit Bestellnummer und einem Foto der
        Minderung — wir tauschen um oder erstatten.
      </P>
      <PH>[Prozess für Gewährleistungsfälle definieren: z.B. Einsendeweg, Kostentragung des Rückversands.]</PH>

      <H2>Reklamationskontakt</H2>
      <P>
        Am schnellsten über unser{" "}
        <a href="/kontakt" className="text-gold underline underline-offset-4">
          Kontaktformular
        </a>{" "}
        oder direkt an support@mazaro.de.
      </P>
    </LegalLayout>
  );
}
